var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { elementChildren, wrapWithComponent } from "../../utils/components";
import { Item } from "./components/Item/Item";
import { StyledStackItem } from "./components/Item/Item.styled";
import { StyledStack } from "./Stack.styled";
var Stack = /** @class */ (function (_super) {
    __extends(Stack, _super);
    function Stack() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Stack.prototype.render = function () {
        var _a = this.props, _b = _a.vertical, vertical = _b === void 0 ? false : _b, children = _a.children, divider = _a.divider, rest = __rest(_a, ["vertical", "children", "divider"]);
        var itemMarkup = elementChildren(children).map(function (child, index) {
            // @ts-ignore
            var showDivider = divider && children.length - 1 > index;
            return (_jsxs(React.Fragment, { children: [wrapWithComponent(child, Item, {}), showDivider && (_jsx(StyledStackItem, { children: divider }, "".concat(index, "Divider")))] }, index));
        });
        return (_jsx(StyledStack, __assign({}, rest, { vertical: vertical, children: itemMarkup })));
    };
    Stack.Item = Item;
    return Stack;
}(React.PureComponent));
export { Stack };
